<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header />
    <HeaderResponsive />
    <div class="container">
      <SecondHeader />
      <div class="row">
        <div class="col-md-9 col-sm-12" style="padding-left: 0; margin-left: -10px">
          <div v-for="(item, index) in filteredCategories" :key="index">

            <br />
            <h2 class="title_section">{{item.name}}</h2>
            <div class="row">
              <div
                class="col-md-3 col-sm-3"
                v-for="(mitigation, index) in item.mitigationActions"
                :key="index"
              >
                <div class="card mb-3" @click="goToExp(mitigation.id)">

                  <div class="row no-gutters">
                    <div class="col-md-12">
                      <img
                        class="card-img"
                        alt="imagenes"
                        style="opacity: 0.9: object-fit: cover"
                        :src="mitigation.actionCover"
                      />
                    </div>
                    <div
                      class="col-md-12"
                      style="position:absolute; bottom: 0px; color: #444; font-weight: bolder"
                    >
                      <div
                        class="card-body"
                        style="background: rgba(0, 0, 0, 0.5); !important margin-bottom: 20px;"
                      >
                        <p
                          class="card-text"
                          style="text-align:right; position: relative; top: 50px; "
                        >
                          <a
                            @click="goToExp(mitigation.id)"
                            style="color: #fff;position: relative;top: -50px;"
                          >
                            <h6
                              style="color:#fff; cursor: pointer "
                            > {{ mitigation.name.substring(0,30)+"..." }}</h6>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 filtros">
          <br />
          <br />
          <h4>Categorías</h4>
          <hr />
          <div class="form-group" v-for="(category, index) in categories" :key="index">
            <input type="radio" :value="category.id" v-model="filter" v-on:click="resetKeywords" />
            {{category.name}}
          </div>
          <div class="form-group">
            <input type="radio" value v-model="filter" />
            Ninguno
          </div>
          <br />
          <div>
            <h4>Palabras clave</h4>
            <hr />
            <vue-tags-input
              add-only-from-autocomplete
              :max-tags="1"
              v-model="keywords"
              :tags="tags"
              :autocomplete-items="filteredKeywords"
              @tags-changed="onTagChange"
              placeholder="Buscar"
            />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeaderMitigacion";
import HeaderResponsive from "./partials/HeaderResponsive";
import Footer from "./partials/Footer";
import { Carousel, Slide } from "./carrousel";
import axios from "axios";
import _ from "lodash";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from "../../helpers/config";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  mounted() {
    this.getMitigationCategories();
    //this.getLevelAdaptation();
  },
  components: {
    Header,
    SecondHeader,
    HeaderResponsive,
    Footer,
    Carousel,
    Slide,
    Loading,
    VueTagsInput,
  },
  computed: {
    // a computed getter
    filteredCategories: function () {
      const key = this.keywords;
      let response = {};
      if (this.filter.length === 0 && this.keywords.length === 0) {
        response = this.categories;
      }
      if (this.filter.length !== 0 && this.keywords.length === 0) {
        response = this.categories.filter(
          (category) => category.id == this.filter
        );
      }
      if (this.filter.length === 0 && this.keywords.length !== 0) {
        response = this.categories.map((c) => {
          return {
            name: c.name,
            mitigationActions: c.mitigationActions.filter((tag) =>
              tag.keywordsSearch.includes(key)
            ),
          };
        });
      }
      if (this.filter.length !== 0 && this.keywords.length !== 0) {
        response = this.categories.map((c) => {
          return {
            name: c.name,
            mitigationActions: c.mitigationActions.filter((tag) =>
              tag.keywordsSearch.includes(key)
            ),
          };
        });
      }

      return response.filter((act) => act.mitigationActions.length > 0);
    },
    filteredKeywords: function () {
      const tags = this.categories
        .map((category) => {
          return category.mitigationActions.map((action) => {
            return action.keywordsSearch.map((key) => {
              return key;
            });
          });
        })
        .flat(2);

      return [...new Set(tags)].map((item) => {
        return { value: item, text: item };
      });
    },
  },
  data() {
    return {
      categories: [],
      filter: "",
      keywords: "",
      adaptationId: null,
      picked: null,
      isLoading: false,
      fullPage: true,
      tags: [],
    };
  },
  methods: {
    onTagChange(event) {
      try {
        this.keywords = event[0].value;
      } catch {
        this.keywords = "";
      }

      //this.resetFilter()
    },
    resetKeywords: function () {
      this.keywords = "";
    },
    resetFilter: function () {
      this.filter = "";
    },
    goToExp(id) {
      console.log(id)
      this.$router.push({ name: "DetalleMitigacion", query: { mid: id } });
    },
    getMitigationCategories() {
      this.isLoading = true;
      axios
        .get(
          `${config.urlApi}/mitigationCategories?filter[include]=mitigationKeywords&filter[include]=mitigationActions`,
          {}
        )
        .then(({ data }) => {
          // this.getImages(data);
          this.categories = data.filter(
            (act) => act.mitigationActions.length > 0
          );
          // this.getAdaptSubIds(data.map(a => a.adaptSubIds));
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.VueCarousel-dot {
  background-color: transparent !important;
}

.title_section {
  color: #3366cc;
  font-weight: bolder;
  margin-bottom: 35px;
  margin-top: 15px;
}

.text-objetivos {
  text-align: justify;
}

.container > .row:nth-child(2n),
.container > .row:nth-child(3n) {
  margin-bottom: 40px;
}

.exp_date {
  font-weight: bolder;
  line-height: 0.3;
}

.filtros {
  margin-top: -75px;
}

.card-body {
  background: #eee;
  color: #000;
  height: 80px;
}

.card-text {
  text-align: right;
  position: relative;
  top: 0px;
}

.card-title {
  margin-top: -50px;
}

@media (max-width: 768px) {
  .filtros {
    margin-top: 0px;
  }
}

.vue-tags-input .ti-item.ti-selected-item {
  background: #069169;
  color: #fff;
}
/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative;
  background: #069169;
  color: #fff;
}
</style>